import { BathroomType } from '../enums/offer/BathroomType';

const bathroomTypeMapping: Record<BathroomType, string> = {
    [BathroomType.UNKNOWN]: '',
    [BathroomType.COMBINED]: 'совмещённый',
    [BathroomType.PARTED]: 'раздельный'
};

export { bathroomTypeMapping };
